import { useEffect, useCallback } from "react";
import { useLocation } from "@/lib/router-compat";
import { supabase } from "@/integrations/supabase/client";

const BOT_PATTERN = /bot|crawl|spider|slurp|bingpreview|mediapartners|facebookexternalhit|twitterbot|linkedinbot|whatsapp|telegram|semrush|ahrefs|mj12bot|dotbot|rogerbot|screaming frog|yandex|baidu|duckduck|sogou|exabot|ia_archiver|archive\.org|googlebot|google-inspectiontool|chrome-lighthouse|pagespeed|gtmetrix|pingdom|uptimerobot|statuscake|headlesschrome|phantomjs|prerender/i;

const isBot = (): boolean => {
  const ua = navigator.userAgent || "";
  if (BOT_PATTERN.test(ua)) return true;
  // Headless browser detection
  if ((navigator as any).webdriver) return true;
  return false;
};

const trackEvent = async (event_type: string, page?: string, metadata?: Record<string, any>) => {
  try {
    if (isBot()) return;
    await supabase.from("analytics_events").insert({
      event_type,
      page: page || window.location.pathname,
      referrer: document.referrer || null,
      user_agent: navigator.userAgent || null,
      metadata: metadata ?? null,
    });
  } catch (_) {
    // silent fail — analytics should never block UX
  }
};

/** Tracks page views on route change */
export const usePageViewTracker = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    // Don't track admin pages
    if (pathname.startsWith("/admin")) return;
    trackEvent("page_view", pathname);
  }, [pathname]);
};

/** Returns a click handler that logs a click-to-call event */
export const useTrackCall = () => {
  return useCallback((page?: string) => {
    trackEvent("click_to_call", page || window.location.pathname);
  }, []);
};

export { trackEvent };
